module.exports = __webpack_public_path__ + "img/pfeil-rechts.8412d425.svg";